import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Typography,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArchiveOutlinedIcon from "@mui/icons-material/ArchiveOutlined";
import UnarchiveOutlinedIcon from "@mui/icons-material/UnarchiveOutlined";
import { Demanda } from "../../pages/suporte/types";
import { styless } from "../../pages/suporte/styles";

interface ArquivarModalProps {
  demanda: Demanda | null;
  onClose: () => void;
  onConfirmar: () => void;
}

export default function ArquivarModal({
  demanda,
  onClose,
  onConfirmar,
}: ArquivarModalProps) {
  const theme = useTheme();
  const styles = styless(theme);
  const restaurar = !!demanda?.arquivada;

  return (
    <Dialog
      open={!!demanda}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      PaperProps={{ sx: styles.modalPaper }}
    >
      {demanda && (
        <>
          <Box sx={styles.modalCabecalho}>
            <Box sx={styles.modalCabecalhoIcone}>
              {restaurar ? (
                <UnarchiveOutlinedIcon sx={{ fontSize: 22 }} />
              ) : (
                <ArchiveOutlinedIcon sx={{ fontSize: 22 }} />
              )}
            </Box>
            <Box sx={styles.modalCabecalhoTextos}>
              <Typography sx={styles.modalCabecalhoTitulo}>
                {restaurar ? "Restaurar chamado?" : "Arquivar chamado?"}
              </Typography>
            </Box>
            <IconButton size="small" onClick={onClose} sx={styles.modalFechar}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          <DialogContent sx={styles.modalConteudo}>
            <Typography
              sx={{
                fontSize: "0.875rem",
                lineHeight: 1.6,
                color: theme.palette.text.secondary,
              }}
            >
              {restaurar ? (
                <>
                  O chamado <strong>{demanda.codigo}</strong> volta a aparecer
                  entre os chamados abertos ou concluídos.
                </>
              ) : (
                <>
                  O chamado <strong>{demanda.codigo}</strong> sai das abas
                  Abertas e Concluídas e passa para Arquivadas. Você pode
                  restaurá-lo quando quiser.
                </>
              )}
            </Typography>
          </DialogContent>

          <DialogActions sx={styles.modalAcoes}>
            <Button
              color="inherit"
              onClick={onClose}
              sx={{ textTransform: "none", borderRadius: 5 }}
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              disableElevation
              onClick={onConfirmar}
              sx={styles.modalCtaPrimaria}
            >
              {restaurar ? "Restaurar" : "Arquivar"}
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
}
